import { render } from "./index.vue?vue&type=template&id=ef7bbf32"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "D:\\01_Dev\\Projects\\active\\YouYouXiChe\\smart-car-wash-background\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__